import { Col, Container, Row } from "react-bootstrap";
// New package button
import { Button } from '@veeyaainnovatives/button';
import { useState, useEffect, useMemo } from 'react';
import { Link } from "react-router-dom";
import EnrollModal from '../components/enroll-modal';
import { useNavigate } from 'react-router-dom';

// New package testimonials
import { Testimonials } from '@veeyaainnovatives/testimonials';
// New package carousel
import { HeroCarousel } from '@veeyaainnovatives/carousel';

// Images
import testimonialOne from '../assets/images/testimonials/testimonial-1.png';
import testimonialIcon from '../assets/images/testimonials/testimonial-icon.png';
import ImageGallery from "../components/sections/image-gallary";
import Counter from "../components/sections/counter";
// import Placement from "../components/sections/placement";
import IntegratedProcess from '../components/sections/integrated-process';
import Enrollment from "../components/sections/enrollment";
import OurServices from "../components/sections/our-services";


import galleryOne from '../assets/images/gallery/gallery-1.jpg';
import galleryTwo from '../assets/images/gallery/gallery-2.jpg';
import galleryThree from '../assets/images/gallery/gallery-3.jpg';
import galleryFour from '../assets/images/gallery/gallery-4.jpg';
import galleryFive from '../assets/images/gallery/gallery-5.jpg';
import gallerySix from '../assets/images/gallery/gallery-6.jpg';
import dots from "../assets/images/dots.png";
import dotsLarge from "../assets/images/dots-large.png";

// New package blog-card
import { BlogCard } from '@veeyaainnovatives/blog-card';
import useCustom from "../hooks/useCustom";
import placeholderImage from '../assets/images/placholder.png';

import AboutUsSection from "../components/sections/about-us-section";

import CarouselImage from '../assets/images/gallery/gallery-3.jpg';
import CarouselImageTwo from '../assets/images/gallery/gallery-5.jpg';
import CarouselImageThree from '../assets/images/gallery/gallery-2.jpg';


const Home = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchBlogs(6);
  }, [])

  const {
    show,
    handleClose,
    syllabus,
    handleShow,
    testimonials,
    homeCounterValue,
    homeHeadingDetails,
    fetchBlogs,
    blogs,
    fetchServices,
    servicesData,
    servicesLoading
  } = useCustom();


  const navigate = useNavigate();

  // Memoize images object to prevent recreation on every render
  const images = useMemo(() => ({
    galleryOne,
    galleryTwo,
    galleryThree,
    galleryFour,
    galleryFive,
    gallerySix
  }), []);

  // Slider settings for testimonials
  const sliderSettings = {
    infinite: true,
    dots: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  // Fetch services from API
  useEffect(() => {
    fetchServices();
  }, []);

  // Carousel slides data
  const carouselSlides = [
    {
      id: 1,
      image: CarouselImage,
      title: (
        <>SDS is Chennai's <strong className="theme-color-tan">No.1</strong> One-Stop <strong className="theme-color-tan">Solution</strong> for <strong className="theme-color-tan">Architecture & Interior</strong> Works</>
      ),
      description: "Get architecture, interiors, construction, and CMDA/DTCP approvals — all handled by a single integrated team with zero outsourcing and zero coordination issues.",
      buttonText: "Get Free Consultation",
      buttonOnClick: handleShow,
      interval: 3000
    },
    {
      id: 2,
      image: CarouselImageTwo,
      title: (
        <>Design + Approvals + Construction <br /> — <strong className="theme-color-tan">All Under One Roof</strong></>
      ),
      description: "SDS is Chennai's first Single-Window Online Approval + Design–Build Studio offering architecture, interior design, structural design, MEP, 3D VR/AR, estimations, and 3D laser scanning.",
      buttonText: "Download 20 Vaastu House Plans",
      buttonOnClick: () => navigate('/vaastu-house-plans'),
      interval: 3000
    },
    {
      id: 3,
      image: CarouselImageThree,
      title: (
        <>Build Your  <strong className="theme-color-tan">Vastu-Compliant</strong>, Modern Home With  <strong className="theme-color-tan">Guaranteed</strong> Timelines</>
      ),
      description: "From concept to completion, SDS ensures transparent pricing, on-time delivery, and approval-ready designs for your dream home.",
      buttonText: "Track Your Project",
      buttonOnClick: handleShow,
      interval: null
    }
  ];

  return (
    <>
      <HeroCarousel slides={carouselSlides} />

      <div className="body-wrap overflow-hidden">
        <section className="section">
          <div className="position-relative pt-1 pt-md-0">
            <div className="design-circle-enroll-your-demo position-absolute"></div>
            <AboutUsSection handleShow={handleShow} />
          </div>
        </section>

        <section className="section">
          <OurServices />
        </section>



        <section className="section">
          <div className="position-relative">
            <div className="design-circle-ui-ux position-absolute"></div>
            <Container >
              <div className="text-center">
                <h1 className="courses-title mb-md-4">Our Core Services</h1>
                <p className="course-syllabus-desc pb-md-5 pb-3">Explore our comprehensive solutions designed to meet your project needs.</p>

              </div>
              {servicesLoading ? (
                <span>Loading...</span>
              ) : servicesData.length === 0 ? (
                <span>No services available</span>
              ) : (
                <Row>
                  {servicesData.map((service, index) => (
                    <Col lg={4} key={service.id} className="mb-4">
                      <div
                        className='serive-list large'
                        onClick={() => navigate(`/services/${service.slug}`)}
                      >
                        <div className='service-icon'>
                          <span className={service.icon} />
                        </div>

                        <div className='service-desc'>
                          <div>
                            <h2 className='sub-service-title'>{service.text}</h2>
                            <p className='sub-service-desc'>{service.excerpt}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
              )}




              {/* <Row>
                <Col lg={4}>
                  <div className="course-card">
                    <div className="course-badge">
                      <i className="fa-regular fa-copy"></i>
                    </div>
                    <h2 className="syllabus-card-title mt-lg-4 mb-lg-4 my-2">Architectural Design in Chennai (Vastu + CMDA Ready)</h2>

                    <p className="syllabus-list">
                      List Down the features here.
                    </p>
                    <p className="syllabus-list">
                      List Down the features here.
                    </p>

                    <p className="syllabus-list">
                      List Down the features here.
                    </p>

                  </div>
                </Col>
                <Col lg={4}>
                  <div className="course-card">
                    <div className="course-badge">
                      <i className="fa-regular fa-copy"></i>
                    </div>
                    <h2 className="syllabus-card-title mt-lg-4 mb-lg-4 my-2">Permit Documentation Services</h2>

                    <p className="syllabus-list">
                      List Down the features here.
                    </p>
                    <p className="syllabus-list">
                      List Down the features here.
                    </p>

                    <p className="syllabus-list">
                      List Down the features here.
                    </p>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="course-card">
                    <div className="course-badge">
                      <i className="fa-regular fa-copy"></i>
                    </div>
                    <h2 className="syllabus-card-title mt-lg-4 mb-lg-4 my-2">Permit Documentation Services</h2>

                    <p className="syllabus-list">
                      List Down the features here.
                    </p>
                    <p className="syllabus-list">
                      List Down the features here.
                    </p>

                    <p className="syllabus-list">
                      List Down the features here.
                    </p>

                  </div>
                </Col>
              </Row> */}
              <div className="text-center my-4 mb-4">
                <Link to="/services">
                  <Button 
                    className="home-button mt-md-4"
                  >
                    View All Services
                  </Button>
                </Link>
              </div>
            </Container>
          </div>
        </section>

        <section className="section">
          <div className="position-relative">
            <div className="design-circle-placement position-absolute"></div>

            <div className="text-center">
              <h1 className="courses-title mb-md-4">Our integrated Process</h1>
              <p className="course-syllabus-desc pb-md-5 pb-3">This is how we deliver a smooth, stress-free construction journey.</p>
            </div>

            <IntegratedProcess />
            {/* <Placement /> */}
          </div>
        </section>

        <section className="section">
          <Enrollment title={'Download Your Free PDF: 20 Vaastu House Plans'} description={"Suitable for Chennai plots → 20’x40’, 30’x40’, 30’x50’, 40’x60’, villa concepts. Laser scanning guide"} btns={['download']} />
        </section>


        
        <section className="section">
          <div className="position-relative">
            <div className="design-circle-work-top position-absolute"></div>

            <Container>
              <h2 className="sds-activitiy-title mb-md-5 mb-4">Our Amazing Projects</h2>
              <ImageGallery images={images} />
              <div className="text-center my-4 mt-5 mt-md-4">
                <Link to="/portfolio">
                  <Button 
                    className="home-button mt-md-4"
                  >
                    View All Projects
                  </Button>
                </Link>
              </div>
            </Container>
            <div className="design-circle-work-bottom position-absolute"></div>

          </div>
        </section>



        {/* Counter Design Section */}
        <section className="section">
          <Counter counterValues={homeCounterValue} />
        </section>

        {/* our Blogs */}
        <section className="section">
          <Container >
            <div className="text-center">
              <h1 className="sds-work-title mb-lg-4">{homeHeadingDetails.title} </h1>
              <p className="our-work-desc pb-md-5 pb-4">{homeHeadingDetails.description}</p>
            </div>
            <BlogCard blogs={blogs} placeholderImage={placeholderImage} />
            <div className="text-center my-md-4">
              <Link to="/blogs">
                <Button 
                  className="home-button mt-4"
                >
                  View All Blogs
                </Button>
              </Link>
            </div>
          </Container>
        </section>


        {/* Testimonials Section - Using @veeyaainnovatives/testimonials package */}
        <Testimonials
          testimonials={testimonials}
          title="Our Happy Clients"
          testimonialIcon={testimonialIcon}
          defaultImage={testimonialOne}
          sliderSettings={sliderSettings}
          dotsTopImage={dotsLarge}
          dotsBottomImage={dots}
          dotsTopClassName="dots-top"
          dotsBottomClassName="dots-bottom"
          className="mt-4"
        />




        {/* <section className="section ">
          <div>
            <Faqsection show={true} />
            <div className="text-center my-md-4 mb-4">
              <Link to="/gallery">
                <Button bsPrefix="home" variant="button" className="mt-md-4" size="lg">
                  View All FAQ's
                </Button>
              </Link>
            </div>
          </div>
        </section> */}

        <section className="section">
          <Enrollment title={'Ready to Build Your Home the Smart Way?'} description={'One team. One platform. One studio for design, approvals, construction, and interiors.'} btns={['whatsapp', 'estimation']} />
        </section>
      </div>

      <EnrollModal
        show={show}
        syllabus={syllabus}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      />
    </>

  );
}

export default Home;
